<div class="{{ className }}">
  @if (!hideLabel) {
    <label [attr.for]="effectiveInputId" [attr.id]="effectiveInputId + '-a11y-label'">{{ 'STUDENT' | translate }}</label>
  }
  @if (form && controlName) {
    <app-auto-complete
      [inputId]="effectiveInputId"
      [labelElementId]="!hideLabel ? effectiveInputId + '-a11y-label' : undefined"
      [ariaLabel]="'STUDENT' | translate"
      (selectedItemChange)="onSelectChangeStudent($event)"
      (searchChange)="onSearchChangeStudent($event)"
      [itemsData]="students"
      [selectedItem]="form.get(controlName)?.value"
      [minTermLength]="1"
    ></app-auto-complete>
  }
</div>
